/**
 * Lightweight API client for form submission.
 * Uses REACT_APP_BACKEND_URL from env — never hardcodes.
 */
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const apiUrl = (path) => `${BACKEND_URL}${path}`;

/**
 * Submit a form to /api/submissions.
 * Returns one of:
 *   { ok: true, submissionId }
 *   { ok: false, status, errors }           — 400 validation
 *   { ok: false, status, error }             — 429/500/network
 */
export const submitForm = async (formType, fields) => {
    const body = { formType, ...fields };
    const metadata = {
        userAgent: navigator.userAgent || "",
        referrer: document.referrer || "",
        pagePath: window.location.pathname || "",
    };
    body.metadata = metadata;

    try {
        const res = await fetch(apiUrl("/api/submissions"), {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(body),
        });
        let data = null;
        try {
            data = await res.json();
        } catch {
            data = null;
        }

        if (res.ok && data && data.success) {
            return { ok: true, submissionId: data.submissionId };
        }
        if (res.status === 400 && data && data.errors) {
            return { ok: false, status: 400, errors: data.errors };
        }
        if (res.status === 429) {
            return {
                ok: false,
                status: 429,
                error:
                    (data && data.error) ||
                    "Too many submissions from this network. Please wait a few minutes and try again.",
            };
        }
        return {
            ok: false,
            status: res.status,
            error:
                (data && data.error) ||
                "We could not submit your form. Please try again, or email hello@vibeforsuccess.org.",
        };
    } catch {
        return {
            ok: false,
            status: 0,
            error:
                "We could not submit your form. Please try again, or email hello@vibeforsuccess.org.",
        };
    }
};
